<template>
  <div class="huasky-store-select">
    <span>所属商户：</span>
    <a-select v-model:value="ids" :mode="mode" @change="change" style="width: 300px" :options="options"
      :allow-clear="mode === 'multiple'"></a-select>
  </div>
</template>
<script setup lang="ts">
import { getSimpleStore } from '@src/scripts/api/store'
import { onMounted } from 'vue'
import { ref } from 'vue'

const props = withDefaults(defineProps<{
  mode?: 'multiple' | 'single'
  value: string[] | string | null
  selected?: boolean
}>(), {
  mode: 'single',
  selected: false
})
const emits = defineEmits(['update:value'])


const ids = ref<string[] | string>(Array.isArray(props.value) ? [] : '')
const options = ref<CommonOption[]>([])

const change = () => {
  emits('update:value', ids.value)
}

onMounted(async () => {
  const stores = await getSimpleStore()
  options.value = stores.data.map((a: any) => ({ label: a.name, value: a.id }))
  if (options.value.length === 0) return
  if (props.selected) {
    if (props.mode === 'single') ids.value = options.value[0].value
    else ids.value = [options.value[0].value]
    change()
  }
})

</script>
<style scoped lang="scss">
.huasky-store-select {
  display: inline-block;
  min-width: 350px;
}
</style>